import { useFormik } from "formik";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../assets/images/common/nefos-logo-new.png";
import logoIcon from "../../assets/images/common/nefos.png";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { CiLock } from "react-icons/ci";
import { MdVisibility } from "react-icons/md";
import { resetPassword } from "../../api/actions/auth";
import toast from "react-hot-toast";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { RxEyeClosed } from "react-icons/rx";
import * as Yup from "yup";
import { RiErrorWarningLine } from "react-icons/ri";

const NewPassword = () => {
  const [showPass, setShowPass] = useState(false);
  const [showConPass, setShowConPass] = useState(false);
  const navigate = useNavigate();
  const { uid, token } = useParams();

  const formik = useFormik({
    validationSchema: Yup.object().shape({
      confirm_password: Yup.string().required("Required"),
      new_password: Yup.string().required("Required"),
    }),
    initialValues: {
      uid: uid,
      token: token,
      new_password: "",
      confirm_password: "",
    },
    // validationSchema,
    onSubmit: (values) => {
      resetPassword(values)((response) => {
        if (response?.status) {
          toast.success("Password Changed Successfully!");
          formik.resetForm();
          navigate("/login");
        } else {
          if (response?.message) {
            toast.error(response?.message);
          }
          formik.setErrors({
            ...formik.errors,
            confirm_password: response?.errors?.["confirm password"] || "",
            new_password: response?.errors?.new_password || "",
          });
        }
      });
    },
  });
  const unmask = () => {
    setShowPass(!showPass);
  };

  const confUnMask = () => {
    setShowConPass(!showConPass);
  };

  return (
    <div className="login-main">
      <div className="login-header">
        <img style={{ width: "100px" }} src={logo} alt="logo" />
        <AiOutlineQuestionCircle style={{ fontSize: "20px" }} />
      </div>
      <div className="login-container">
        <Container>
          <div className="login-box-container">
            <Row>
              <div className="login-box">
                <div className="login-title">
                  <div
                    style={{
                      backgroundColor: "white",
                      width: "60px",
                      height: "60px",
                      borderRadius: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <img style={{ width: "50px" }} src={logoIcon} alt="logo" />
                  </div>
                  <h3>New password</h3>
                </div>
                <div className="login-input-box">
                  <Form onSubmit={formik.handleSubmit}>
                    <div
                      className="login-input-field"
                      style={{
                        border:
                          formik.touched?.new_password &&
                          !!formik?.errors?.new_password
                            ? "2px solid #dc3545"
                            : "",
                      }}
                    >
                      <CiLock />

                      <Form.Control
                        type={showPass ? "text" : "password"}
                        placeholder="New password"
                        name="new_password"
                        onChange={formik.handleChange}
                        value={formik.values.new_password}
                        minLength={8}
                      />
                      {formik.values.new_password ? (
                        <button
                          className="password-button_icon"
                          type="button"
                          onClick={unmask}
                        >
                          {showPass ? <MdVisibility /> : <RxEyeClosed />}
                        </button>
                      ) : (
                        ""
                      )}
                      {formik.touched?.new_password &&
                        !!formik?.errors?.new_password && (
                          <div className="show-valid">
                            <RiErrorWarningLine
                              style={{
                                color: "#dc3545",
                                fontSize: "29px",
                                cursor: "pointer",
                              }}
                            />

                            <p>{formik?.errors?.new_password}</p>
                          </div>
                        )}
                    </div>

                    <div
                      className="login-input-field"
                      style={{
                        border:
                          formik.touched?.confirm_password &&
                          !!formik?.errors?.confirm_password
                            ? "2px solid #dc3545"
                            : "",
                      }}
                    >
                      <CiLock />
                      <Form.Control
                        type={showConPass ? "text" : "password"}
                        placeholder="Confirm password"
                        name="confirm_password"
                        onChange={formik.handleChange}
                        value={formik.values.confirm_password}
                        minLength={8}
                      />
                      {formik.values.confirm_password ? (
                        <button
                          className="password-button_icon"
                          type="button"
                          onClick={confUnMask}
                        >
                          {showConPass ? <MdVisibility /> : <RxEyeClosed />}
                        </button>
                      ) : (
                        ""
                      )}
                      {formik.touched?.confirm_password &&
                        !!formik?.errors?.confirm_password && (
                          <div className="show-valid">
                            <RiErrorWarningLine
                              style={{
                                color: "#dc3545",
                                fontSize: "29px",
                                cursor: "pointer",
                              }}
                            />

                            <p>{formik?.errors?.confirm_password}</p>
                          </div>
                        )}
                    </div>

                    <div className="login-submit-btn">
                      <button type="submit">Reset password</button>
                    </div>
                  </Form>
                </div>
              </div>
            </Row>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default NewPassword;
